import { TicketCommentDto } from "./TicketCommentDto";
import { TicketCommentModel } from "./TicketCommentModel";

export const transformTicketCommentDtoToModel = (
  dto: TicketCommentDto
): TicketCommentModel => dto;
